export default {
  UNPROCESSED: "unprocessed",
  PROCESSED: "processed",
  OUTBOX: "outbox",
  CONCEPTS: "concepts",
};
